module.exports = __webpack_public_path__ + "static/C&J_color run friends.dbbaa60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/C&J_color run friends.png
// module id = 91
// module chunks = 104101334113578 114276838955818